export default __webpack_public_path__ + "static/media/mobile_apiaries_image.88292bb4.png";